<template>
  <input
    v-bind="mergedAttrs"
    :type="inputType"
    :class="[mergedAttrs.class, inputClass]"
    :value="displayValue"
    @input="onInput"
    @change="onChange"
    @blur="emitClose"
  />
</template>

<script>
import { DateTime } from 'luxon'

export default {
  name: 'Datetime',
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number, Date],
      default: ''
    },
    value: {
      type: [String, Number, Date],
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-LL-dd'
    },
    type: {
      type: String,
      default: 'date'
    },
    inputClass: {
      type: String,
      default: ''
    },
    zone: {
      type: String,
      default: ''
    },
    valueZone: {
      type: String,
      default: ''
    },
    phrases: {
      // Kept for API compatibility
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:modelValue', 'input', 'change', 'close'],
  computed: {
    mergedAttrs () {
      const { class: className, ...attrs } = this.$attrs
      return {
        class: className,
        ...attrs
      }
    },
    inputType () {
      if (this.type === 'datetime' || this.type === 'datetime-local') {
        return 'datetime-local'
      }
      if (this.type === 'time') {
        return 'time'
      }
      return 'date'
    },
    displayValue () {
      const current = this.modelValue !== undefined && this.modelValue !== null && this.modelValue !== ''
        ? this.modelValue
        : this.value
      if (current === undefined || current === null || current === '') {
        return ''
      }
      const parsed = this.parseToDateTime(current)
      if (!parsed || !parsed.isValid) {
        return current
      }
      return parsed.setZone(this.zone || this.valueZone || 'local').toFormat(this.inputFormat)
    },
    inputFormat () {
      if (this.inputType === 'datetime-local') {
        return "yyyy-LL-dd'T'HH:mm"
      }
      if (this.inputType === 'time') {
        return 'HH:mm'
      }
      return 'yyyy-LL-dd'
    }
  },
  methods: {
    parseToDateTime (value) {
      const zone = this.valueZone || this.zone || 'local'
      let dt = null
      if (value instanceof Date) {
        dt = DateTime.fromJSDate(value, { zone })
      } else if (typeof value === 'number') {
        dt = DateTime.fromMillis(value, { zone })
      } else if (typeof value === 'string') {
        dt = DateTime.fromISO(value, { zone })
        if (!dt.isValid && this.format) {
          dt = DateTime.fromFormat(value, this.format, { zone })
        }
      }
      return dt
    },
    onInput (event) {
      const raw = event.target.value
      if (!raw) {
        this.$emit('update:modelValue', '')
        this.$emit('input', '')
        return
      }
      const zone = this.zone || this.valueZone || 'local'
      const parsed = DateTime.fromISO(raw, { zone })
      const formatted = parsed.isValid ? parsed.setZone(zone).toFormat(this.format || this.inputFormat) : raw
      this.$emit('update:modelValue', formatted)
      this.$emit('input', formatted)
    },
    onChange () {
      this.$emit('change', this.modelValue)
    },
    emitClose () {
      this.$emit('close', this.modelValue)
    }
  }
}
</script>
